import { render } from "./FooterNavigation.vue?vue&type=template&id=53be1935&scoped=true"
const script = {}

import "./FooterNavigation.vue?vue&type=style&index=0&id=53be1935&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53be1935"

export default script